export default function (ctrl) {
	return function () {
		ctrl.serviceNotAvailable = false;
	};
}
